import { typePageOptions } from '@/utils';
import { accountTie, keyboardReturn } from '@/utils/icons';
import { required } from '@/utils/rules';
import { cell_phone } from '@/utils/masks';
import { getTypeUser } from '@/utils';
import { TYPE_USER } from '@/utils/enums';
import ListPayments from '@/views/Settings/Customers/pages/components/ListPayments';
import CustomerBusiness from '@/business/CustomerBusiness';

export default {
  domain: 'customers',
  domainSingle: 'customer',
  business: CustomerBusiness,
  title: 'Clientes',
  description: 'Lista de todos os clientes cadastrados no sistema',
  createBtn: getTypeUser() === TYPE_USER.RESELLER ? 'Novo Cliente' : false,
  routes: {
    list: {
      name: 'settings-customers',
      path: '/configuracoes/clientes',
      meta: { typePage: typePageOptions.list, requiresAuth: true, }
    },
    create: {
      name: 'settings-customer-create',
      path: '/configuracoes/clientes/novo',
      meta: { typePage: typePageOptions.create, requiresAuth: true, }
    },
    show: {
      name: 'settings-customer-show',
      path: '/configuracoes/clientes/:id',
      meta: { typePage: typePageOptions.show, requiresAuth: true, }
    }
  },
  listActions: {
    has: true,
    noShow: false,
    noDestroy: true,
    noUpdate: true,
    more: {
      has: true,
      items: [
        {
          icon: keyboardReturn,
          name: 'listPayments',
          iconColor: 'primary',
          label: 'Listar Pagamentos',
          action: 'listPayments',
          component: ListPayments,
          version: 'v2',
          updateListWhenClosing: true,
          maxWidth: 1000,
        },
      ]
    },
  },
  filters: {
    has: false,
    items: []
  },
  fields: [
    {
      title: 'Dados do Cliente',
      icon: accountTie,
      openGroup: true,
      readonly: true,
      items: [
        {
          type: 'text',
          name: 'name',
          formattedName: 'name',
          label: 'Nome',
          align: '',
          md: '5',
          rules: [required],
          list: true,
          readonly: false,
          disabled: false,
          counter: 100,
        },
        {
          type: 'text',
          name: 'email',
          formattedName: 'email',
          label: 'Email',
          align: '',
          md: '4',
          rules: [required],
          list: true,
          readonly: false,
          disabled: false,
        },
        {
          type: 'simpleMask',
          name: 'cell_phone',
          formattedName: 'cell_phone',
          label: 'Celular',
          align: '',
          md: '3',
          rules: [required],
          inputMask: cell_phone,
          outputMask: '###########',
          list: true,
          readonly: false,
          clearable: false,
          disabled: false,
        },
        {
          type: 'text',
          name: 'subscription_status',
          formattedName: 'subscription_status',
          label: 'Status da Assinatura',
          align: '',
          md: '3',
          rules: [],
          list: true,
          readonly: false,
          clearable: false,
          disabled: false,
        },
      ],
    },
  ],
  footer: []
};
